import { render, staticRenderFns } from "./BillingAccordionPanel.vue?vue&type=template&id=eda0e23a&scoped=true&"
import script from "./BillingAccordionPanel.vue?vue&type=script&lang=js&"
export * from "./BillingAccordionPanel.vue?vue&type=script&lang=js&"
import style0 from "./BillingAccordionPanel.vue?vue&type=style&index=0&id=eda0e23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda0e23a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eda0e23a')) {
      api.createRecord('eda0e23a', component.options)
    } else {
      api.reload('eda0e23a', component.options)
    }
    module.hot.accept("./BillingAccordionPanel.vue?vue&type=template&id=eda0e23a&scoped=true&", function () {
      api.rerender('eda0e23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/BillingAccordionPanel.vue"
export default component.exports